export enum LOCALE {
  GB = 'en_GB',
}

export const localeName = {
  [LOCALE.GB]: 'English (United Kingdom)',
};
